//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Layout2d.js";
import "../no/Builder.js";
import "../no/SelectView.js";
import "../no/SelectObject.js";
let d=[[[0,"Name",1,0],[0,"Number",1,0],[0,"ProjectionAngleType",1,0],[0,"Revision",1,0],[0,"SecondaryNumber",1,0],[1,"SelectLayoutSheetView",0,"SelectView",0]],[[["numerator","denominator"],"GetScale",{},0,0],[["numerator","denominator"],"SetScale",{},2,0]],[]];
SPLM.Layout2d.ConvertLayoutToSheetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Layout2d.ConvertLayoutToSheetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Layout2d.ConvertLayoutToSheetBuilder.SheetProjectionAngleType = Object.freeze({
    "First" : "First", "Third" : "Third"});

export default SPLM;